
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!calendar.edit_calendar_event_full";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'calendar/editCalendarEventFull';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function", self=this;

function program1(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("calendar.edit_calendar_event_full")
  },data:data},helper ? helper.call(depth0, "new_calendar_event_header", "New Calendar Event", options) : helperMissing.call(depth0, "t", "new_calendar_event_header", "New Calendar Event", options)))
    + "\n  ";
  return buffer;
  }

function program3(depth0,data) {
  
  var helper, options;
  return escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("calendar.edit_calendar_event_full")
  },data:data},helper ? helper.call(depth0, "edit_calendar_event_header", "Edit Calendar Event", options) : helperMissing.call(depth0, "t", "edit_calendar_event_header", "Edit Calendar Event", options)));
  }

function program5(depth0,data) {
  
  
  return "use_section_dates";
  }

function program7(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <div class=\"clearfix  pull-right\">\n      <a href=\"#\" class=\"switch_event_description_view pull-right\">\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("calendar.edit_calendar_event_full")
  },data:data},helper ? helper.call(depth0, "#editor.switch_editor_html", "HTML Editor", options) : helperMissing.call(depth0, "t", "#editor.switch_editor_html", "HTML Editor", options)))
    + "\n      </a>\n      <a href=\"#\" class=\"switch_event_description_view pull-right\" style=\"display:none;\">\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("calendar.edit_calendar_event_full")
  },data:data},helper ? helper.call(depth0, "#editor.switch_editor_rich_text", "Rich Content Editor", options) : helperMissing.call(depth0, "t", "#editor.switch_editor_rich_text", "Rich Content Editor", options)))
    + "\n      </a>\n    </div>\n    <div style=\"clear:both;\"></div>\n  ";
  return buffer;
  }

function program9(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <label class=\"label_with_checkbox\" for=\"use_section_dates\">\n      "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{},data:data},helper ? helper.call(depth0, "use_section_dates", options) : helperMissing.call(depth0, "checkbox", "use_section_dates", options)))
    + "\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("calendar.edit_calendar_event_full")
  },data:data},helper ? helper.call(depth0, "different_date_for_each_section", "Use a different date for each section", options) : helperMissing.call(depth0, "t", "different_date_for_each_section", "Use a different date for each section", options)))
    + "\n    </label>\n\n    <input type=\"hidden\"\n           name=\"remove_child_events\"\n           value=\"";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.use_section_dates), {hash:{},inverse:self.noop,fn:self.program(10, program10, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\" />\n\n    <div class=\"show_if_using_sections\">\n      ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.course_sections), {hash:{},inverse:self.noop,fn:self.program(12, program12, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n  ";
  return buffer;
  }
function program10(depth0,data) {
  
  
  return "1";
  }

function program12(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      <label class=\"row_header\" for=\"section_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_start_date\">";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</label>\n      <div class=\"date_start_end_row\">\n        <div class=\"date_field_container\">\n          <input type=\"text\"\n                 id=\"section_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_start_date\"\n                 name=\"child_event_data[";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "][start_date]\"\n                 class=\"date_field start_date\"\n                 value=\""
    + escapeExpression((helper = helpers.tDateToString || (depth0 && depth0.tDateToString),options={hash:{},data:data},helper ? helper.call(depth0, ((stack1 = (depth0 && depth0.event)),stack1 == null || stack1 === false ? stack1 : stack1.start_at), "medium", options) : helperMissing.call(depth0, "tDateToString", ((stack1 = (depth0 && depth0.event)),stack1 == null || stack1 === false ? stack1 : stack1.start_at), "medium", options)))
    + "\"\n                 aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("calendar.edit_calendar_event_full")
  },data:data},helper ? helper.call(depth0, "date", "Date", options) : helperMissing.call(depth0, "t", "date", "Date", options)))
    + "\"\n                 placeholder=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("calendar.edit_calendar_event_full")
  },data:data},helper ? helper.call(depth0, "date", "Date", options) : helperMissing.call(depth0, "t", "date", "Date", options)))
    + "\" />\n        </div>\n        <div class=\"time_range_container\">\n          <div class='date_field_container'>\n            <input type=\"text\"\n                   name=\"child_event_data[";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "][start_time]\"\n                   class=\"time_field start_time\"\n                   ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.all_day), {hash:{},inverse:self.noop,fn:self.program(13, program13, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                   aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("calendar.edit_calendar_event_full")
  },data:data},helper ? helper.call(depth0, "start_time", "Start Time", options) : helperMissing.call(depth0, "t", "start_time", "Start Time", options)))
    + "\"\n                   placeholder=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("calendar.edit_calendar_event_full")
  },data:data},helper ? helper.call(depth0, "start_time", "Start Time", options) : helperMissing.call(depth0, "t", "start_time", "Start Time", options)))
    + "\" />\n          </div>\n          <span class=\"time_separator\">-</span>\n          <div class='date_field_container'>\n            <input type=\"text\"\n                   name=\"child_event_data[";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "][end_time]\"\n                   class=\"time_field end_time\"\n                   ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.all_day), {hash:{},inverse:self.noop,fn:self.program(15, program15, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                   aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("calendar.edit_calendar_event_full")
  },data:data},helper ? helper.call(depth0, "end_time", "End Time", options) : helperMissing.call(depth0, "t", "end_time", "End Time", options)))
    + "\"\n                   placeholder=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("calendar.edit_calendar_event_full")
  },data:data},helper ? helper.call(depth0, "end_time", "End Time", options) : helperMissing.call(depth0, "t", "end_time", "End Time", options)))
    + "\" />\n            <input type=\"hidden\"\n                   name=\"child_event_data[";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "][context_code]\"\n                   value=\"course_section_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" />\n          </div>\n        </div>\n      </div>\n      ";
  return buffer;
  }
function program13(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += " value=\""
    + escapeExpression((helper = helpers.tTimeToString || (depth0 && depth0.tTimeToString),options={hash:{},data:data},helper ? helper.call(depth0, ((stack1 = (depth0 && depth0.event)),stack1 == null || stack1 === false ? stack1 : stack1.start_at), "tiny", options) : helperMissing.call(depth0, "tTimeToString", ((stack1 = (depth0 && depth0.event)),stack1 == null || stack1 === false ? stack1 : stack1.start_at), "tiny", options)))
    + "\" ";
  return buffer;
  }

function program15(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += " value=\""
    + escapeExpression((helper = helpers.tTimeToString || (depth0 && depth0.tTimeToString),options={hash:{},data:data},helper ? helper.call(depth0, ((stack1 = (depth0 && depth0.event)),stack1 == null || stack1 === false ? stack1 : stack1.end_at), "tiny", options) : helperMissing.call(depth0, "tTimeToString", ((stack1 = (depth0 && depth0.event)),stack1 == null || stack1 === false ? stack1 : stack1.end_at), "tiny", options)))
    + "\" ";
  return buffer;
  }

function program17(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += " value=\""
    + escapeExpression((helper = helpers.tTimeToString || (depth0 && depth0.tTimeToString),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.start_at), "tiny", options) : helperMissing.call(depth0, "tTimeToString", (depth0 && depth0.start_at), "tiny", options)))
    + "\" ";
  return buffer;
  }

function program19(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += " value=\""
    + escapeExpression((helper = helpers.tTimeToString || (depth0 && depth0.tTimeToString),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.end_at), "tiny", options) : helperMissing.call(depth0, "tTimeToString", (depth0 && depth0.end_at), "tiny", options)))
    + "\" ";
  return buffer;
  }

function program21(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n  <fieldset>\n    <label for=\"calendar_event_conference_selection\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "conferencing_b69e2537", "Conferencing:", options) : helperMissing.call(depth0, "t", "conferencing_b69e2537", "Conferencing:", options)))
    + "</label>\n    <div id=\"calendar_event_conference_selection\"></div>\n  </fieldset>\n  ";
  return buffer;
  }

function program23(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n  <label class=\"label_with_checkbox\" for=\"duplicate_event\">\n    <input type=\"checkbox\" id=\"duplicate_event\" name=\"duplicate\" value=\"true\"/>\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("calendar.edit_calendar_event_full")
  },data:data},helper ? helper.call(depth0, "repeat", "Duplicate", options) : helperMissing.call(depth0, "t", "repeat", "Duplicate", options)))
    + "\n  </label>\n\n  <div class=\"duplicate_event_row duplicate_fields\" style=\"display: none\">\n    <label for=\"duplicate_interval\">\n      <div class=\"duplicate_label\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "every_665d821e", "Every", options) : helperMissing.call(depth0, "t", "every_665d821e", "Every", options)))
    + "</div>\n      <input value=\"1\" disabled=\"true\" type=\"number\" id=\"duplicate_interval\" name=\"duplicate_interval\" min=\"1\" />\n      <select id=\"duplicate_frequency\" name=\"duplicate_frequency\">\n        <option value=\"daily\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "day_s_7cc1231f", "Day(s)", options) : helperMissing.call(depth0, "t", "day_s_7cc1231f", "Day(s)", options)))
    + "</option>\n        <option value=\"weekly\" selected>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "week_s_cb1492ee", "Week(s)", options) : helperMissing.call(depth0, "t", "week_s_cb1492ee", "Week(s)", options)))
    + "</option>\n        <option value=\"monthly\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "month_s_5c17590e", "Month(s)", options) : helperMissing.call(depth0, "t", "month_s_5c17590e", "Month(s)", options)))
    + "</option>\n      </select>\n    </label>\n  </div>\n\n  <div class=\"duplicate_event_row duplicate_fields\" style=\"display: none\">\n    <label for=\"duplicate_count\">\n      <div class=\"duplicate_label\" >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "for_974cbb84", "For", options) : helperMissing.call(depth0, "t", "for_974cbb84", "For", options)))
    + "</div>\n      <input value=\"1\" disabled=\"true\" type=\"number\" id=\"duplicate_count\" name=\"duplicate_count\" min=\"1\" max=\"";
  if (helper = helpers.recurringEventLimit) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.recurringEventLimit); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" />\n      <span class=\"occurences_div\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "additional_occurrence_s_7b5b0173", "additional occurrence(s)", options) : helperMissing.call(depth0, "t", "additional_occurrence_s_7b5b0173", "additional occurrence(s)", options)))
    + "</span>\n    </label>\n  </div>\n\n  <div class=\"duplicate_event_row duplicate_fields\" style=\"display: none\">\n    <label for=\"append_iterator\" class=\"label_with_checkbox\" data-tooltip title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "appends_a_number_to_the_end_of_each_event_title_e__bca98abd", "Appends a number to the end of each event title (e.g. Event 1, Event 2, etc)", options) : helperMissing.call(depth0, "t", "appends_a_number_to_the_end_of_each_event_title_e__bca98abd", "Appends a number to the end of each event title (e.g. Event 1, Event 2, etc)", options)))
    + "\">\n      <input value=\"true\" disabled=\"true\" type=\"checkbox\" id=\"append_iterator\" name=\"append_iterator\" />\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "number_each_event_d934cd65", "Number each event", options) : helperMissing.call(depth0, "t", "number_each_event_d934cd65", "Number each event", options)))
    + "\n    </label>\n  </div>\n  ";
  return buffer;
  }

function program25(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      <button type=\"button\" class=\"btn delete_link\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("calendar.edit_calendar_event_full")
  },data:data},helper ? helper.call(depth0, "delete", "Delete", options) : helperMissing.call(depth0, "t", "delete", "Delete", options)))
    + "</button>\n    ";
  return buffer;
  }

function program27(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      <a href=\"";
  if (helper = helpers.return_to_url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.return_to_url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\"btn\" role=\"button\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("calendar.edit_calendar_event_full")
  },data:data},helper ? helper.call(depth0, "#buttons.cancel", "Cancel", options) : helperMissing.call(depth0, "t", "#buttons.cancel", "Cancel", options)))
    + "</a>\n    ";
  return buffer;
  }

function program29(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("calendar.edit_calendar_event_full")
  },data:data},helper ? helper.call(depth0, "buttons.create", "Create Event", options) : helperMissing.call(depth0, "t", "buttons.create", "Create Event", options)))
    + "\n      ";
  return buffer;
  }

function program31(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("calendar.edit_calendar_event_full")
  },data:data},helper ? helper.call(depth0, "buttons.update", "Update Event", options) : helperMissing.call(depth0, "t", "buttons.update", "Update Event", options)))
    + "\n      ";
  return buffer;
  }

  buffer += "<h1 class=\"screenreader-only\">\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.newRecord), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</h1>\n<form id=\"editCalendarEventFull\" class=\"";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.use_section_dates), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n  <input type=\"text\"\n         name=\"title\"\n         class=\"title input-block-level\"\n         aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("calendar.edit_calendar_event_full")
  },data:data},helper ? helper.call(depth0, "event_title", "Event Title", options) : helperMissing.call(depth0, "t", "event_title", "Event Title", options)))
    + "\"\n         placeholder=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("calendar.edit_calendar_event_full")
  },data:data},helper ? helper.call(depth0, "event_title", "Event Title", options) : helperMissing.call(depth0, "t", "event_title", "Event Title", options)))
    + "\"\n         value=\"";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n         maxlength=\"255\" />\n\n  ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.use_rce_enhancements), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  <textarea class=\"input-block-level\"\n            id=\"calendar-description\"\n            name=\"description\"\n            aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("calendar.edit_calendar_event_full")
  },data:data},helper ? helper.call(depth0, "event_description", "Event Description", options) : helperMissing.call(depth0, "t", "event_description", "Event Description", options)))
    + "\"\n            style=\"width: 100%\">";
  if (helper = helpers.description) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.description); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</textarea>\n\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.course_sections), {hash:{},inverse:self.noop,fn:self.program(9, program9, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n  <div class=\"hide_if_using_sections date_start_end_row\">\n    <div class=\"date_field_container\">\n      <label class='screenreader-only' id='calendar_event_date_accessible_label'>\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "event_date_c9459fe3", "Event Date", options) : helperMissing.call(depth0, "t", "event_date_c9459fe3", "Event Date", options)))
    + "\n        "
    + escapeExpression((helper = helpers.datepickerScreenreaderPrompt || (depth0 && depth0.datepickerScreenreaderPrompt),options={hash:{},data:data},helper ? helper.call(depth0, "date", options) : helperMissing.call(depth0, "datepickerScreenreaderPrompt", "date", options)))
    + "\n      </label>\n      <input type=\"text\"\n             name=\"start_date\"\n             class=\"date_field start_date\"\n             value=\"";
  if (helper = helpers.start_date) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.start_date); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n             placeholder=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("calendar.edit_calendar_event_full")
  },data:data},helper ? helper.call(depth0, "date", "Date", options) : helperMissing.call(depth0, "t", "date", "Date", options)))
    + "\"\n             aria-labelledby='calendar_event_date_accessible_label'\n             data-tooltip title=\""
    + escapeExpression((helper = helpers.accessibleDateFormat || (depth0 && depth0.accessibleDateFormat),options={hash:{},data:data},helper ? helper.call(depth0, "date", options) : helperMissing.call(depth0, "accessibleDateFormat", "date", options)))
    + "\"/>\n    </div>\n    <div class=\"time_range_container\">\n      <div class='date_field_container'>\n        <label class='screenreader-only' id='calendar_event_start_time_accessible_label'>\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "event_start_time_441b491f", "Event Start Time", options) : helperMissing.call(depth0, "t", "event_start_time_441b491f", "Event Start Time", options)))
    + "\n          "
    + escapeExpression((helper = helpers.datepickerScreenreaderPrompt || (depth0 && depth0.datepickerScreenreaderPrompt),options={hash:{},data:data},helper ? helper.call(depth0, "time", options) : helperMissing.call(depth0, "datepickerScreenreaderPrompt", "time", options)))
    + "\n        </label>\n        <input type=\"text\"\n               name=\"start_time\"\n               class=\"time_field start_time\"\n               ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.all_day), {hash:{},inverse:self.noop,fn:self.program(17, program17, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n               placeholder=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("calendar.edit_calendar_event_full")
  },data:data},helper ? helper.call(depth0, "start_time", "Start Time", options) : helperMissing.call(depth0, "t", "start_time", "Start Time", options)))
    + "\"\n               aria-labelledby='calendar_event_start_time_accessible_label'\n               data-tooltip title=\""
    + escapeExpression((helper = helpers.accessibleDateFormat || (depth0 && depth0.accessibleDateFormat),options={hash:{},data:data},helper ? helper.call(depth0, "time", options) : helperMissing.call(depth0, "accessibleDateFormat", "time", options)))
    + "\"/>\n      </div>\n      <span class=\"time_separator\">-</span>\n      <div class='date_field_container'>\n        <label class='screenreader-only' id='calendar_event_end_time_accessible_label'>\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "event_end_time_ef830e66", "Event End Time", options) : helperMissing.call(depth0, "t", "event_end_time_ef830e66", "Event End Time", options)))
    + "\n          "
    + escapeExpression((helper = helpers.datepickerScreenreaderPrompt || (depth0 && depth0.datepickerScreenreaderPrompt),options={hash:{},data:data},helper ? helper.call(depth0, "time", options) : helperMissing.call(depth0, "datepickerScreenreaderPrompt", "time", options)))
    + "\n        </label>\n        <input type=\"text\"\n               name=\"end_time\"\n               class=\"time_field end_time\"\n               ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.all_day), {hash:{},inverse:self.noop,fn:self.program(19, program19, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n               placeholder=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("calendar.edit_calendar_event_full")
  },data:data},helper ? helper.call(depth0, "end_time", "End Time", options) : helperMissing.call(depth0, "t", "end_time", "End Time", options)))
    + "\"\n               aria-labelledby='calendar_event_end_time_accessible_label'\n               data-tooltip title=\""
    + escapeExpression((helper = helpers.accessibleDateFormat || (depth0 && depth0.accessibleDateFormat),options={hash:{},data:data},helper ? helper.call(depth0, "time", options) : helperMissing.call(depth0, "accessibleDateFormat", "time", options)))
    + "\"/>\n      </div>\n    </div>\n  </div>\n\n  <fieldset>\n    <label class=\"location_label\" for=\"calendar_event_location_name\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("calendar.edit_calendar_event_full")
  },data:data},helper ? helper.call(depth0, "location_name", "Location:", options) : helperMissing.call(depth0, "t", "location_name", "Location:", options)))
    + "</label>\n    <input id=\"calendar_event_location_name\" name=\"location_name\" size=\"30\" maxlength=\"255\" type=\"text\" value=\"";
  if (helper = helpers.location_name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.location_name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"/>\n  </fieldset>\n\n  <fieldset>\n    <label class=\"location_label\" for=\"calendar_event_location_address\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("calendar.edit_calendar_event_full")
  },data:data},helper ? helper.call(depth0, "location_address", "Address:", options) : helperMissing.call(depth0, "t", "location_address", "Address:", options)))
    + "</label>\n    <input id=\"calendar_event_location_address\" name=\"location_address\" size=\"30\" maxlength=\"255\" type=\"text\" value=\"";
  if (helper = helpers.location_address) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.location_address); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"/>\n  </fieldset>\n\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.include_conference_selection), {hash:{},inverse:self.noop,fn:self.program(21, program21, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.newRecord), {hash:{},inverse:self.noop,fn:self.program(23, program23, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n  <div class=\"form-actions\">\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.url), {hash:{},inverse:self.noop,fn:self.program(25, program25, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.return_to_url), {hash:{},inverse:self.noop,fn:self.program(27, program27, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    <button type=\"submit\" class=\"btn btn-primary\">\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.newRecord), {hash:{},inverse:self.program(31, program31, data),fn:self.program(29, program29, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </button>\n  </div>\n\n</form>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  